module.exports = __webpack_public_path__ + "img/Rex Reynolds.9bd27781.jpg";